import { EventData } from '../../lib/events/constants';
import { tracker } from '../../lib/events/tracker';

export const handleDataTracker = (eventName: string, eventDataName = '', programName = '', leadData:any = {}) => {
  
  const storedFormValues: any = JSON.parse(localStorage.getItem('formData'));
  const arrSplitName = eventName.split("-");
  const lastWord = arrSplitName[arrSplitName.length - 1];
  
  let userEventData:any = {};
  if(lastWord == 'otp')
  {
    userEventData = {
      first_name: storedFormValues['first_name'],
      last_name: storedFormValues['last_name'],
      email: storedFormValues['email'],
      mobile: `${storedFormValues['isd']}${' '}${storedFormValues['phone']}`,
      leadIdentifier: leadData?.leadIdentifier || '',
      course_name: leadData?.program || '',
    }
  }

  if (eventName == '' && eventDataName.length) {
    const eventTrackingLable = `${programName.split(" ")[0]}_${eventDataName}`;
    
    tracker({
      trackerType: 'all',
      eventName: eventTrackingLable,
      eventLabel: eventTrackingLable,
      eventAction: eventTrackingLable,
      data: { course_name: programName, ...userEventData },
    });
  } else {
    
    let data = EventData[eventName];
    let trackerData;
    if (typeof data?.isOTPVerified != 'undefined') {
      trackerData = { isOTPVerified: data.isOTPVerified ? 'Yes' : 'No' };
    }

    if (data) {
      tracker({
        trackerType: 'all',
        eventName: `${programName.split(" ")[0]}_${data.name}`,
        eventLabel: data.label,
        eventAction: data.action,
        data: { ...trackerData, course_name: programName, ...userEventData },
      });
    }
  }
};
